import { render } from "./fromto.vue?vue&type=template&id=7bc8d26a&ts=true"
import script from "./fromto.vue?vue&type=script&lang=ts"
export * from "./fromto.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__